<template>
  <div class="quote u-pad-y-md u-flex u-center">
    <div class="u-relative u-w7of12">
      <div class="quote__icon quote__icon--left" v-if="!$device.isTablet">&ldquo;</div>
      <p class="u-uppercase t-text--big u-white-space t-bold" :class=" data.backgroundColored ? 'u-white' : 'u-blue' ">{{ data.quote }}</p>
      <p class="u-pad-x-1of12--sm u-inline-block u-marg-t-sm u-white-space u-black">
        {{ data.author }}<span class="t-italic" v-if="data.job">, {{ data.job }}</span>
      </p>
      <div class="quote__icon quote__icon--right" v-if="!$device.isTablet">&rdquo;</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Quote',
   props: {
    data: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="stylus">
@import '~@/styles/settings/mixins/viewport-sizer'
@import '~@/styles/settings/variables'
@import '~@/styles/settings/mixins/mq'

.quote
  &__icon
    position absolute
    viewportSizer('font-size', 170, 1920)
    viewportSizer('line-height', 50, 1920)
    +mq($from: 'wide')
      font-size 170px
      line-height 170px
    
    &--left
      top 0
      right calc(100% + 15px)

    &--right
      bottom 0
      left calc(100% + 15px)
    
</style>